import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import * as firebase from 'firebase';
import { Breadcrumb } from '@blueprintjs/core'
import Form from './contactForm/Form'
import ReactGA from 'react-ga'


class Contact extends Component {

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }
    render() {
        return (

            <div>
                <ul className="pt-breadcrumbs">
                <li><Breadcrumb href="/home" text="Home" /></li>
                <li><Breadcrumb href="/contact" text="Contact" /></li>
                </ul> 
                <hr/>
                <div>
                <h3>Contact Us</h3>
                <Form />
                </div>
            </div>

            
        );
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.jsx